export const common = {
  // Resources page (researcher-managed article library)
  resources_tab_label: 'Resources',
  resources_search_placeholder: 'Search resources…',
  resources_empty: 'No resources yet.',
  common_home_title: 'Home',
  common_cancel: 'Cancel',
  common_close: 'Close',
  common_questionnaire: 'Questionnaire',
  common_clear: 'Clear',
  common_save: 'Save',
  common_mail: 'Email',
  common_sms: 'Sms',
  common_copy: 'Copy',
  common_name: 'First name',
  common_surname: 'Last name',
  common_lang: 'Language',
  common_phone: 'Phone',
  common_next: 'Next',
  common_previous: 'Previous',
  common_details: 'Details',
  common_send: 'Send',
  common_start: 'Start',
  common_password: 'Password',
  common_click_to_speak: 'Click to speak',
  common_server_error_title: 'A server error has occurred',
  common_server_error_desc: 'Please try again or contact us',
  common_go_back: 'Go back',
  common_nodata_title: 'There is no data available',
  common_nodata_desc: 'Please try again or contact us',
  common_retry: 'Retry',
  common_bad_request: 'Bad request',
  common_no_slug: 'Please click on the invitation link in your email or SMS messages',
  common_submit: "Submit",
  common_sending: "Sending",
  common_thanks_bug_report: "Thank you for reporting this bug!",
  common_open: "Open",
  common_your_email: "Your email",
  common_bug_description: "Your message",
  common_all_fields_required: "Please fill all the fields",
  common_error_occurred: "An error occurred. Please try again.",
  common_attachments: "Attachments",
  common_attachment_add: "Add files",
  common_attachment_limit: "Maximum {{count}} files",
  common_attachment_size_limit: "Each file must be smaller than {{sizeMb}} MB",
  common_attachment_type_not_allowed: "One or more files are not supported",
  common_remove: "Remove",
  common_dropdown_title: "Please select:",
  common_dropdown_close_button: "Close",
  confirm_quit_study_button: 'Leave Permanently',
  come_back_later_button: 'I will come back later',
  doing_questionnaire_button: 'I am doing a questionnaire',
  help_link_part1: 'If you are not feeling well, you can ',
  help_link_part2: 'get help by clicking here',
  thank_you: 'Thank you!',
  you_earned_part1: 'You have earned ',
  you_earned_part2: ' points!',
  other_questionnaire: 'You can help us further by filling out another questionnaire.',
  add_to_home_screen_prompt: "Add {{appName}} to your home screen.",
  pwa_install_button: "Install the app",
  pwa_install_button_aria: "Install the {{appName}} app",
  pwa_install_hint: "Open the <kbd>⋮</kbd> menu, then choose <strong>Install app</strong>.",
  pwa_ios_title: "Install {{appName}}",
  pwa_ios_subtitle: "Add this app to your home screen",
  pwa_ios_description: "Tap the Share button, then select “Add to Home Screen”.",
  pwa_ios_share_step: "1. Tap the Share button.",
  pwa_ios_add_step: "2. Select “Add to Home Screen”.",
};
